import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
import {CardEvent, PaymentTrackingAction} from "./structs/CardEvent";


export class CreditCard extends AbstractPage {
    protected validated: boolean = false;
    protected payBtnDisabled: boolean = true;

    protected expiryMonth: JQuery<HTMLElement> = null;
    protected expiryYear: JQuery<HTMLElement> = null;
    protected expiryField: JQuery<HTMLElement> = null;
    protected changedMonth: boolean = false;
    protected changedYear: boolean = false;

    constructor(app: JqueryApp) {
        super(app);
        CardEvent.setWebHelpers(this.webHelpers, this.app.getConfig());

        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.app.$('#confirm-purchase').removeAttr('disabled');
            this.payBtnDisabled = false;
        });
    }

    public styleCards() {
        const $ = this.app.$;
        const form = $('#payauth-form');
        if (form.length === 0)
            return;

        $('#screen-width').val($(this.webHelpers.window).width());
        $('#screen-height').val($(this.webHelpers.window).height());

        //const owner = this.app.$('#owner');
        const cardNumber = $('#cardNumber');
        const cardNumberField = $('#card-number-field');
        const cvvNumberField = $('#cvv-number-field');
        const CVV = $("#cvv");
        const mastercard = $("#mastercard");

        this.expiryField = $('#expiration-date');
        this.expiryMonth = $("#credit_expiry_month");
        this.expiryYear = $("#credit_expiry_year");
        const visa = $("#visa");
        const amex = $("#amex");

        // Use the payform library to format and validate
        // the payment fields.

        // TODO add timer event with ping?

        cardNumber.payform('formatCardNumber');
        CVV.payform('formatCardCVC');

        cardNumber.on("change", () => {
            amex.removeClass('transparent').removeClass('active');
            visa.removeClass('transparent').removeClass('active');
            mastercard.removeClass('transparent').removeClass('active');

            if ($.payform.validateCardNumber(cardNumber.val() as string) == false) {
                cardNumberField.addClass('has-error');
                this.showCardError("invalidCc");
            }
            else {
                cardNumberField.removeClass('has-error');
                cardNumberField.addClass('has-success');
                this.removeCardError("invalidCc");
                const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionInput, "User entered card number");
            }

            if ($.payform.parseCardType(cardNumber.val() as string) == 'visa') {
                visa.addClass('active');
                mastercard.addClass('transparent');
                amex.addClass('transparent');
            }
            else if ($.payform.parseCardType(cardNumber.val() as string) == 'amex') {
                amex.addClass('active');
                mastercard.addClass('transparent');
                visa.addClass('transparent');
            }
            else if ($.payform.parseCardType(cardNumber.val() as string) == 'mastercard') {
                mastercard.addClass('active');
                amex.addClass('transparent');
                visa.addClass('transparent');
            }
        });

        CVV.on("change", () => {
            //if (CVV.is(":focus"))
                //return;
            if ($.payform.validateCardCVC(CVV.val() as string) == false) {
                cvvNumberField.addClass('has-error');
                this.showCardError("invalidCvv");
            }
            else {
                cvvNumberField.removeClass('has-error');
                cvvNumberField.addClass('has-success');
                this.removeCardError("invalidCvv");
                const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionInput, "User entered CVV");
            }
        });

        this.expiryMonth.on("change", () => {
            this.changedMonth = true;
            if (this.changedYear === true) // validate if both have been changed
                this.validateExpiration();
            const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionInput, "User entered expiry month");
        });

        this.expiryYear.on("change", () => {
            this.changedYear = true;
            if (this.changedMonth === true)
                this.validateExpiration();
            const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionInput, "User entered expiry year");
        });

        //confirmButton.on("click", (e) => {
        form.on("submit", (e) => {
            if (this.validated === true)
                return;
            e.preventDefault();

            const isCardValid = $.payform.validateCardNumber(cardNumber.val() as string);
            const isCvvValid = $.payform.validateCardCVC(CVV.val() as string);
            const isValidExpiry = this.validateExpiration();

            //if((owner.val() as string).length < 5){
            if (!isCardValid) {
                const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionUserAction, "User clicked pay: invalid Card no");
                console.warn("Invalid card number");
                this.showCardError("invalidCc");
            }
            else if (!isCvvValid) {
                const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionUserAction, "User clicked pay: invalid CVV");
                console.warn("Invalid CVV"); // also catches date in the past
                this.showCardError("invalidCvv");
            }
            else if (!isValidExpiry) { // check if expiration date in the past
                const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionUserAction, "User clicked pay: invalid expiration date");
                console.warn("Invalid expiration date");
                // card err already shown
            }
            else {
                // Everything is correct. Add your form submission code here.
                const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionUserAction, "User clicked pay: validation passed");
                this.clearCardError();
                this.validated = true;
                if (this.payBtnDisabled === true) {
                  const event = new CardEvent(PaymentTrackingAction.PaymentTrackingActionError, "User clicked pay twice - prevented");
                    console.warn("User clicked pay twice. Please wait before clicking again.");
                    return;
                }

                this.disablePayButtonTimer();
                //form.submit(); // use submit event to catch enter
                form.trigger("submit");
            }
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected validateExpiration(): boolean {
        const isValidExpiry = $.payform.validateCardExpiry(this.expiryMonth.val() as string, this.expiryYear.val() as string);

        if (isValidExpiry == false) {
            this.expiryField.addClass('has-error');
            this.showCardError("invalidExp");
            return false;
        }
        this.removeCardError("invalidExp");
        this.expiryField.removeClass('has-error');
        this.expiryField.addClass('has-success');
        return true;
    }

    protected disablePayButtonTimer() {
        const confirmButton = this.app.$('#confirm-purchase');
        confirmButton.attr('disabled', "true");
        this.payBtnDisabled = true;

        setTimeout(() => {
            confirmButton.removeAttr('disabled');
            this.payBtnDisabled = false;
            }, 12000);
    }

    protected showCardError(errLabel: string): void {
        let err = this.app.getTr().get(errLabel);
        if (!err)
            err = this.app.getTr().get("unknownErr");
        this.app.$("#pay-cc-error").html(err).fadeIn("slow");
    }

    protected removeCardError(errLabel: string): void {
        let err = this.app.getTr().get(errLabel);
        if (this.app.$("#pay-cc-error").html() === err)
            this.clearCardError();
    }

    protected clearCardError(): void {
        this.app.$("#pay-cc-error").html("").fadeOut("slow");
    }
}
